import JobsGrid from "./jobs-grid";

import "./job-grids.scss";


const JobGrids = {
    All : JobsGrid
};

export default JobGrids;